import type { ConversationAssistant, AssistantInfo } from './MgaApi';
import { RAG_ASSISTANT_ID, RAG_ASSISTANT_INFO } from './RagAssistantAdapter';
import {
  BACKSTAGE_AGENT_ASSISTANT_ID,
  BACKSTAGE_AGENT_ASSISTANT_INFO,
} from './BackstageAgentAdapter';

export const LOCAL_ASSISTANT_INFOS = [
  RAG_ASSISTANT_INFO,
  BACKSTAGE_AGENT_ASSISTANT_INFO,
];

export const LOCAL_ASSISTANT_IDS = LOCAL_ASSISTANT_INFOS.map(
  assistant => assistant.id,
);

export const LOCAL_CONVERSATION_PREFIXES = {
  [RAG_ASSISTANT_ID]: 'rag',
  [BACKSTAGE_AGENT_ASSISTANT_ID]: 'agent',
} as const;

export const isLocalAssistantId = (assistantId?: string): boolean =>
  assistantId !== undefined && LOCAL_ASSISTANT_IDS.includes(assistantId);

export const isRagConversationId = (conversationId?: string): boolean =>
  conversationId?.startsWith(
    `${LOCAL_CONVERSATION_PREFIXES[RAG_ASSISTANT_ID]}-`,
  ) ?? false;

export const isBackstageAgentConversationId = (
  conversationId?: string,
): boolean =>
  conversationId?.startsWith(
    `${LOCAL_CONVERSATION_PREFIXES[BACKSTAGE_AGENT_ASSISTANT_ID]}-`,
  ) ?? false;

export const isLocalConversationId = (conversationId?: string): boolean =>
  isRagConversationId(conversationId) ||
  isBackstageAgentConversationId(conversationId);

export const getLocalAssistantInfo = (
  assistantId?: string,
): ConversationAssistant | undefined =>
  LOCAL_ASSISTANT_INFOS.find(assistant => assistant.id === assistantId);

export const isRagAssistant = (assistantId?: string): boolean =>
  assistantId === RAG_ASSISTANT_ID;

export const isBackstageAgentAssistant = (assistantId?: string): boolean =>
  assistantId === BACKSTAGE_AGENT_ASSISTANT_ID;

export const toAssistantInfo = (
  assistant: ConversationAssistant,
): AssistantInfo => {
  const now = new Date().toISOString();

  return {
    id: assistant.id,
    name: assistant.name,
    description: assistant.description || '',
    instructions: assistant.instructions || '',
    temperature: 0.7,
    model: {
      model: assistant.model || assistant.name,
      name: assistant.name,
      description: assistant.description || '',
    },
    topic: assistant.topic || '',
    tools: [],
    files: [],
    starter_messages: [],
    total_conversations: 0,
    total_stars: 0,
    total_unique_users: 0,
    logo_url: assistant.logoUrl || '',
    creation_date: now,
    modification_date: now,
  };
};
